var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaneles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 100.0 100.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l100.0 0l0 100.0l-100.0 0l0 -100.0z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    fillOpacity: 0,
    d: "m0 0l100.0 0l0 100.0l-100.0 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m63.607273 21.159868l11.822475 0c-1.3058777 0 -2.3644943 2.8763256 -2.3644943 6.42445c0 3.5481262 1.0586166 6.424452 2.3644943 6.424452l-11.822475 0l0 0c-1.3058739 0 -2.3644943 -2.8763256 -2.3644943 -6.424452c0 -3.5481243 1.0586205 -6.42445 2.3644943 -6.42445z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m27.513123 21.16159l44.972878 0l0 12.845455l-44.972878 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m27.242828 21.159868l11.822475 0c-1.3058739 0 -2.3644943 2.8763256 -2.3644943 6.42445c0 3.5481262 1.0586205 6.424452 2.3644943 6.424452l-11.822475 0l0 0c-1.3058739 0 -2.3644943 -2.8763256 -2.3644943 -6.424452c0 -3.5481243 1.0586205 -6.42445 2.3644943 -6.42445z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m63.6067 37.50842l11.822475 0c-1.3058777 0 -2.3644943 2.8763275 -2.3644943 6.4244537c0 3.5481262 1.0586166 6.42445 2.3644943 6.42445l-11.822475 0l0 0c-1.3058777 0 -2.3644981 -2.8763237 -2.3644981 -6.42445c0 -3.5481262 1.0586205 -6.4244537 2.3644981 -6.4244537z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m27.512548 37.510143l44.97287 0l0 12.845455l-44.97287 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m27.242254 37.50842l11.822474 0c-1.3058739 0 -2.3644943 2.8763275 -2.3644943 6.4244537c0 3.5481262 1.0586205 6.42445 2.3644943 6.42445l-11.822474 0l0 0c-1.3058739 0 -2.3644943 -2.8763237 -2.3644943 -6.42445c0 -3.5481262 1.0586205 -6.4244537 2.3644943 -6.4244537z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m63.6067 53.85812l11.822475 0c-1.3058777 0 -2.3644943 2.8763275 -2.3644943 6.4244537c0 3.5481224 1.0586166 6.42445 2.3644943 6.42445l-11.822475 0l0 0c-1.3058777 0 -2.3644981 -2.8763275 -2.3644981 -6.42445c0 -3.5481262 1.0586205 -6.4244537 2.3644981 -6.4244537z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m27.512548 53.859844l44.97287 0l0 12.845455l-44.97287 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m27.242254 53.85812l11.822474 0c-1.3058739 0 -2.3644943 2.8763275 -2.3644943 6.4244537c0 3.5481224 1.0586205 6.42445 2.3644943 6.42445l-11.822474 0l0 0c-1.3058739 0 -2.3644943 -2.8763275 -2.3644943 -6.42445c0 -3.5481262 1.0586205 -6.4244537 2.3644943 -6.4244537z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m63.607273 70.20667l11.822475 0c-1.3058777 0 -2.3644943 2.8763275 -2.3644943 6.4244537c0 3.5481262 1.0586166 6.424446 2.3644943 6.424446l-11.822475 0l0 0c-1.3058739 0 -2.3644943 -2.87632 -2.3644943 -6.424446c0 -3.5481262 1.0586205 -6.4244537 2.3644943 -6.4244537z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m27.513123 70.2084l44.972878 0l0 12.845451l-44.972878 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m27.242828 70.20667l11.822475 0c-1.3058739 0 -2.3644943 2.8763275 -2.3644943 6.4244537c0 3.5481262 1.0586205 6.424446 2.3644943 6.424446l-11.822475 0l0 0c-1.3058739 0 -2.3644943 -2.87632 -2.3644943 -6.424446c0 -3.5481262 1.0586205 -6.4244537 2.3644943 -6.4244537z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m63.6067 86.55637l11.822475 0c-1.3058777 0 -2.3644943 2.8763275 -2.3644943 6.4244537c0 3.5481262 1.0586166 6.424446 2.3644943 6.424446l-11.822475 0l0 0c-1.3058777 0 -2.3644981 -2.87632 -2.3644981 -6.424446c0 -3.5481262 1.0586205 -6.4244537 2.3644981 -6.4244537z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m27.512548 86.5581l44.97287 0l0 12.845451l-44.97287 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m27.242254 86.55637l11.822474 0c-1.3058739 0 -2.3644943 2.8763275 -2.3644943 6.4244537c0 3.5481262 1.0586205 6.424446 2.3644943 6.424446l-11.822474 0l0 0c-1.3058739 0 -2.3644943 -2.87632 -2.3644943 -6.424446c0 -3.5481262 1.0586205 -6.4244537 2.3644943 -6.4244537z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m35.492065 13.447312l0 0c-1.3587341 -1.358736 -1.3587341 -3.5616808 0 -4.920416q2.460209 -2.460208 2.460209 -7.380624q0 4.920416 2.460209 7.380624l0 0c1.3587341 1.3587351 1.3587341 3.5616798 0 4.920416l0 0c-1.358738 1.3587351 -3.5616798 1.3587351 -4.920418 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m60.428375 13.447312l0 0c-1.3587341 -1.358736 -1.3587341 -3.5616808 0 -4.920416q2.460209 -2.460208 2.460209 -7.380624q0 4.920416 2.460209 7.380624l0 0c1.3587341 1.3587351 1.3587341 3.5616798 0 4.920416l0 0c-1.358738 1.3587351 -3.5616837 1.3587351 -4.920418 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m47.96022 17.2364l0 0c-1.3587341 -1.358736 -1.3587341 -3.5616817 0 -4.920417q2.460209 -2.460208 2.460209 -7.3806233q0 4.9204154 2.460209 7.3806233l0 0c1.3587341 1.3587351 1.3587341 3.5616808 0 4.920417l0 0c-1.358738 1.3587341 -3.5616837 1.3587341 -4.920418 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m2.082934 56.399876l9.103458 0l0 -3.8832664l7.7665386 7.7665367l-7.7665386 7.7665367l0 -3.8832703l-9.103458 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m81.04619 56.399876l9.103455 0l0 -3.8832664l7.7665405 7.7665367l-7.7665405 7.7665367l0 -3.8832703l-9.103455 0z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaneles);
export default __webpack_public_path__ + "static/media/paneles.c859a9f8e6cca115d4d5bbf33e3d6d48.svg";
export { ForwardRef as ReactComponent };